import React, { useState } from 'react'
import AllUsersTable from '../../molecules/AllUsersTable/AllUsersTable'
import { image } from '../../../app/utils/common/image';
import FilterModal from '../../atoms/FilterModal/FilterModal';
import { useAppDispatch, useAppSelector } from '../../../app/utils/hooks/reduxHook';
import { getAllUsersAPI } from '../../../redux/API/AllUsersAPI';
import { setAllUsersFilter } from '../../../redux/Slices/allUsersSlice';

const AllUsers = () => {
    const [filterModal, setFilterModal] = useState<boolean>(false);
    const { searchText } = useAppSelector((state) => state.search)
    const { allUserFilter, pagination } = useAppSelector((state) => state.allUsers);
    
    const dispatch = useAppDispatch();
        const filterModalOptions = [
            {
                key: "active",
                value: "Active Account"
            },
            {
                key: "deleted",
                value: "Deleted Account"
            },
        ]
        const fetchFilterData = (sortBy: string) => {
            dispatch(getAllUsersAPI({ page: pagination.current_page, role_id: 2, searchText: searchText,  filterBy: sortBy
            }));
            dispatch(setAllUsersFilter(sortBy))
        }
    
    return (
        <div className='manager_container'>
            <div className='manager_header'>
                <div className='allManager'>
                    All Users
                </div>

                 <div className='button_container'>
                    {(allUserFilter !== "" || null || undefined) && <div className='filter_count'><span>1</span></div>}
                        <div className='btn' onClick={() => setFilterModal(!filterModal)}>
                            <img className='btn_icon' src={image.FILTER_ICON} />
                                <div>
                                    Filter
                                </div>
                        </div>
                </div>
            </div>

            <div className='manager_data_table'>
                <AllUsersTable />
            </div>

            {filterModal && (
                <div className='filter_modal_wrapper'>
                    <FilterModal
                        selectedFilter={allUserFilter}
                        options={filterModalOptions}
                        handleSubmit={(data) => {
                            fetchFilterData(data.key);
                            setFilterModal(false);
                        }}

                        handleRemoveFilter={() => {
                            dispatch(setAllUsersFilter(''));
                            dispatch(getAllUsersAPI({
                                page: pagination.current_page,
                                role_id: 2,
                                searchText: searchText, 
                                filterBy: "all"
                            }));
                            setFilterModal(false);
                        }}
                        containerClassName={"filter_modal_container_2"}
                        onOutSideClick={() => setFilterModal(false)}
                    />

                </div>
            )}
        </div>
    )
}

export default AllUsers